export default __webpack_public_path__ + "static/bryan-ford-f584587c6045d5c2e828192117a4f1a9.jpg";